import { ApiClient } from '../../ApiClient';
import { TaskDTO } from '../dto/TaskDTO';

export class TaskDataSource {
  constructor(private api: ApiClient) {}

  async getTasks(unfinishedOnly = false): Promise<TaskDTO[]> {
    const response = await this.api.get<TaskDTO[]>('/tasks', {
      params: unfinishedOnly ? { unfinishedOnly: true } : undefined,
    });
    return response.data;
  }

  async acknowledgeTask(taskId: string): Promise<TaskDTO> {
    const response = await this.api.post<TaskDTO>(`/tasks/${taskId}/acknowledge`);
    return response.data;
  }
}
